import { executePost } from "../ServiceMethods";
import { enduserId, removeUserCredentials, userId } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

export const InsertChatApi = async (MessageData, cb) => {
  const id = userId();
  const endUser_Id = enduserId();
  const data = {
    user_id: userId(),
  };

  try {
    const insertMessage = await executePost("/chat/message", {
      api_method: "post",
      eu_id: endUser_Id,
      bu_id: MessageData.bu_id,
      channel_id: MessageData.channel_id,
      product_id: MessageData.product_id,
      product_type: MessageData.product_type,
      help_reason: MessageData.help_reason,
    });
    const insertMessageData = insertMessage.data ? insertMessage.data : {};
    return insertMessageData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
